import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import { IconContext } from '../context';

function IconInfoComponent(iconProps, ref) {
  const _useContext = useContext(IconContext),
        _useContext$prefixCls = _useContext.prefixCls,
        prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  const spin = iconProps.spin,
        className = iconProps.className;
  const props = {
    "aria-hidden": true,
    focusable: false,
    ref,
    ...iconProps,
    className: `${className ? className + ' ' : ''}${prefixCls}-icon ${prefixCls}-icon-info`
  };

  if (spin) {
    props.className = `${props.className} ${prefixCls}-icon-loading`;
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25 39H27V60H25z",
    transform: "rotate(180 25 39)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M25 39H27V60H25z",
    transform: "rotate(180 25 39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 11H27V13H25z",
    transform: "rotate(180 25 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M25 11H27V13H25z",
    transform: "rotate(180 25 11)"
  }));
}

const IconInfo = /*#__PURE__*/React.forwardRef(IconInfoComponent);
IconInfo.defaultProps = {
  isIcon: true
};
IconInfo.displayName = 'IconInfo';
export default IconInfo;